const message ={
    intro :"RACE GROUP vous propose une nouvelle mission :\n\n{mission_title}",
    link: "Cliquez sur le lien suivant pour la consulter :\n\n{mission_link}",
    signature: "L'équipe RACE GROUP"
};

export default message;
